export default "__VITE_ASSET__BHncNtKE__"